import React from "react";
import { motion } from "framer-motion";

const stats = [
  { k: "12+", v: "Years guiding leaders & organizations" },
  { k: "$15M+", v: "Raised across nonprofit & growth campaigns" },
  { k: "1:1", v: "Personal partnership in every engagement" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <div className="flex items-center gap-3 mb-6">
              <span className="ssg-hero-rule" />
              <span className="text-[11px] tracking-[0.28em] uppercase font-bold text-[#9B1C1C]">
                About
              </span>
            </div>
            <h2
              data-testid="about-heading"
              className="font-display text-4xl md:text-5xl lg:text-6xl font-black tracking-tight text-neutral-950 leading-[0.95]"
            >
              The<br />
              <span className="italic font-light">strategist</span><br />
              behind SSG.
            </h2>
            <div className="mt-10 hidden lg:block">
              <div className="aspect-[3/4] bg-[#0A0A0A] relative overflow-hidden">
                <img
                  src="https://customer-assets-jai6qajn.emergentagent.net/job_ssg-coaching/artifacts/v7acnpwl_E606117E-8E94-461D-A3BD-47AAA9DD596A.png"
                  alt="Brady Smith — strategist & coach"
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute -bottom-px -right-px h-20 w-20 bg-[#9B1C1C]" />
              </div>
            </div>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-8 lg:pt-10"
        >
          <p className="font-display text-2xl md:text-3xl lg:text-[34px] leading-[1.25] tracking-tight text-neutral-900 font-medium">
            I help people and organizations close the gap between where they
            are <span className="text-[#9B1C1C]">and what they are capable of becoming.</span>
          </p>

          <div className="mt-10 ssg-divider" />

          <div className="mt-10 space-y-7 text-[17px] leading-relaxed text-neutral-700 font-body">
            <p>
              I&apos;m <strong className="text-neutral-950 font-bold">Brady Smith</strong> —
              a strategist, coach, fundraiser, communicator, and builder of
              people and systems. For more than a decade I&apos;ve sat at the
              intersection of leadership, growth, and storytelling — helping
              founders, executives, and mission-driven organizations turn
              ambition into structure.
            </p>
            <p>
              Smith Strategic Group is the work I&apos;ve spent my career
              preparing for. It&apos;s where coaching meets strategy. Where the
              human behind the title gets the same attention as the
              organization they&apos;re building. I&apos;ve led teams, run
              campaigns, raised meaningful capital, rebuilt brands, and
              walked beside leaders through some of the most defining
              seasons of their lives.
            </p>
            <p>
              What I bring is not theory. It&apos;s lived practice — a
              grounded, confident, and personal approach to helping you move
              from clarity to conviction, and from intention to execution.
            </p>
          </div>

          <div className="mt-14 grid sm:grid-cols-3 gap-px bg-neutral-200">
            {stats.map((s, i) => (
              <div
                key={i}
                data-testid={`about-stat-${i}`}
                className="bg-white p-8"
              >
                <div className="font-display text-4xl md:text-5xl font-black tracking-tight text-neutral-950">
                  {s.k}
                </div>
                <div className="mt-3 text-[12px] tracking-[0.18em] uppercase font-semibold text-neutral-500 leading-snug">
                  {s.v}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 inline-flex items-center gap-4 text-[12px] tracking-[0.24em] uppercase font-bold text-neutral-900">
            <span className="w-10 h-px bg-[#9B1C1C]" />
            Brady Smith · Founder & Principal Strategist
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
